<hlm-dialog [state]="open() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-dialog-content *hlmDialogPortal class="sm:max-w-md">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>Kunde mit Schenkwerk-Konto</h3>
      <p hlmDialogDescription>
        Gib die E-Mail-Adresse ein, mit der sich dein Kunde bei Schenkwerk anmeldet. Wir fragen ihn
        per E-Mail, ob du in seinem Konto arbeiten darfst. Stimmt er zu, erscheint er hier in deiner
        Liste.
      </p>
    </div>

    <form
      [formGroup]="form"
      (ngSubmit)="submit()"
      class="flex flex-col gap-5"
      novalidate
      id="request-access-form">
      <div hlmField>
        <label hlmFieldLabel for="request-access-email">Anmelde-E-Mail deines Kunden</label>
        <input
          hlmInput
          id="request-access-email"
          type="email"
          inputmode="email"
          formControlName="email"
          autocomplete="off"
          placeholder="inhaber@geschaeft.de"
          class="w-full"
          [attr.aria-invalid]="emailInvalid ? 'true' : null" />
        @if (emailInvalid) {
          <p hlmFieldDescription class="text-destructive">
            Bitte gib eine gültige E-Mail-Adresse ein
          </p>
        }
      </div>

      @if (error()) {
        <div hlmAlert variant="destructive" role="alert">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>{{ error() }}</p>
        </div>
      }
    </form>

    <div hlmDialogFooter>
      <button hlmBtn variant="outline" type="button" [disabled]="loading()" (click)="dismiss()">
        Abbrechen
      </button>
      <button
        hlmBtn
        type="submit"
        form="request-access-form"
        [disabled]="loading()"
        [attr.aria-busy]="loading()">
        @if (loading()) {
          <hlm-spinner />
        }
        Kunden fragen
      </button>
    </div>
  </hlm-dialog-content>
</hlm-dialog>
